import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { withRouter } from "../withRouter";
import {
  authVoter,
  createAnswer,
  createVoter,
  getEventByUrl,
  getEventColors,
  getQuestionsEvent,
  getVoter,
  getVoterByLink,
  updateUserStatus,
} from "../api";
import Alert from "react-bootstrap/Alert";
import { withTheme } from "../withTheme";
import VoterNavBar from "./VoterNavBar.js";
import bandesPhoviaH from "../assets/bandes_phovia_h.svg";
import LoadingButton from "./LoadingButton";
import { BASE_URL } from "../config.js";
import { Spinner } from "react-bootstrap";
class VoterRegister extends Component {
  state = {
    questions: [],
    answers: {},
    event: null,
    username: null,
    showRegisterAlert: "",
    isUsernameValid: false,
    allQuestionsAnswered: true,
    conditionNotMet: false,
    questionnaireType: "filter",
    footerHeight: 54,
    voterProfession: null,
    projectProfessions: [],
  };
  vh = window.innerHeight * 0.01;
  handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    this.setState((prevState) => {
      let petsType = [...prevState.petsType];
      if (checked && !petsType.includes(value)) {
        petsType.push(value);
      } else if (!checked && petsType.includes(value)) {
        petsType = petsType.filter((item) => item !== value);
      }

      return { petsType };
    });
  };

  // Génère un pseudo aléatoire pour les votants inéligibles (qui ne saisissent
  // pas de username mais doivent être créés pour garder la trace).
  generateRandomUsername = () => {
    return (
      "anon-" +
      Math.random().toString(36).slice(2, 8) +
      Math.random().toString(36).slice(2, 6)
    );
  };

  // Source de vérité du type d'étape : les PROPS (location.state), à jour dès la
  // navigation. NE PAS utiliser this.state.questionnaireType ici : il est mis à
  // jour de façon asynchrone dans componentDidUpdate (await), donc en retard
  // d'un render -> race condition qui faisait créer le votant avec un pseudo
  // aléatoire au lieu du username saisi (=> reconnexion impossible).
  currentQuestionnaireType = () => {
    return this.props.location.state?.questionnaire_type || "filter";
  };

  // L'étape "username" est la DERNIÈRE étape du questionnaire d'inscription :
  // post-filtre s'il existe (et placé "start"), sinon le filtre lui-même.
  // Le username n'est demandé QUE sur cette étape (évite le doublon).
  isUsernameStep = () => {
    const { with_presenter, position, post_filter_questionnaire_enabled, form_placement } =
      this.props.location.state;
    if (!with_presenter || position !== "start") return false;
    const isFilter = this.currentQuestionnaireType() !== "post_filter";
    const filterFollowedByPostFilter =
      isFilter && post_filter_questionnaire_enabled && form_placement === "start";
    return !filterFollowedByPostFilter;
  };

  allQuestionsAnswered = () => {
    return this.state.questions.every((question) => {
      if (question.mandatory) {
        const answer = this.state.answers[question.id]?.answer;
        if (Array.isArray(answer)) {
          return answer.length > 0; // For checkbox type questions, check if at least one option is selected
        } else {
          return answer !== undefined && answer !== ""; // For other types, check if the answer is not undefined or empty
        }
      }
      return true;
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    if (event.target.name === "username") {
      this.setState({
        isUsernameValid: event.target.value.length > 4,
      });
    }
  };

  handleAnswerChange = (event, questionId, type) => {
    const { value, checked } = event.target;

    if (type === "checkbox") {
      this.setState((prevState) => {
        let answers = { ...prevState.answers };
        let answer = answers[questionId]?.answer || [];

        if (checked) {
          answer.push(value);
        } else {
          answer = answer.filter((option) => option !== value);
        }

        answers[questionId] = { answer };

        return { answers };
      });
    } else {
      this.setState({
        answers: {
          ...this.state.answers,
          [questionId]: { answer: value },
        },
      });
    }
  };

  // Filtre par profession : uniquement en mode non-présentateur. Un votant
  // n'a une profession que si le projet en définit ; une question sans
  // professions s'applique à tous.
  filterByProfession = (questions, voterProfession) => {
    const { with_presenter } = this.props.location.state;
    if (with_presenter || !voterProfession) {
      return questions;
    }
    return questions.filter(
      (q) => !q.professions?.length || q.professions.includes(voterProfession)
    );
  };

  async componentDidMount() {
    window.addEventListener("resize", this.setVHValue);

    this.setState({ loading: true });
    this.setVHValue();

    const event = await getEventByUrl(this.props.location.state.unique_str);
    const colors = await getEventColors(event.id);

    // Projet à professions (mode non-présentateur) : le votant doit avoir
    // choisi sa profession avant toute question — sinon, passage par le
    // picker qui reviendra ici avec le même state.
    const { unique_str, unique_link, with_presenter } =
      this.props.location.state;
    let voterProfession = null;
    if (!with_presenter && !event.with_presenter) {
      if (unique_link) {
        let projectProfessions = [];
        try {
          const voterInfo = await getVoterByLink(event.id, unique_link);
          voterProfession = voterInfo.profession || null;
          projectProfessions = voterInfo.project_professions || [];
        } catch (e) {
          console.log(e);
        }
        if (projectProfessions.length > 0 && !voterProfession) {
          this.props.navigate(
            "/events/" + unique_str + "/voter/profession",
            {
              state: {
                unique_str,
                unique_link,
                return_to_path:
                  "/events/" + unique_str + "/voter/register",
                forward_state: this.props.location.state,
              },
            }
          );
          return;
        }
      } else {
        // Questionnaire en position "end" : pas de unique_link dans le
        // state mais le votant est déjà authentifié (token) et sa
        // profession déjà choisie via le gate de VoterSession.
        try {
          const voter = await getVoter(event.id);
          voterProfession = voter.profession || null;
        } catch (e) {
          console.log(e);
        }
      }
    }

    const allQuestions = await getQuestionsEvent(event.id);

    // Filtrer les questions selon le type de questionnaire
    const questionnaireType = this.props.location.state.questionnaire_type || "filter";
    const questions = this.filterByProfession(
      allQuestions.filter(q => {
        if (questionnaireType === "post_filter") {
          return q.is_post_filter === true;
        } else {
          return !q.is_post_filter; // false ou null
        }
      }),
      voterProfession
    ).sort((a, b) => a.order - b.order);

    this.setState({
      colors,
      event,
      questions,
      questionnaireType,
      voterProfession,
      loading: false,
    });
  }

  async componentDidUpdate(prevProps) {
    // Check if questionnaire_type changed (navigating from filter to post_filter)
    const prevType = prevProps.location.state?.questionnaire_type || "filter";
    const currentType = this.props.location.state?.questionnaire_type || "filter";

    if (prevType !== currentType) {
      this.setState({ loading: true });

      const allQuestions = await getQuestionsEvent(this.state.event.id);
      const questions = this.filterByProfession(
        allQuestions.filter(q => {
          if (currentType === "post_filter") {
            return q.is_post_filter === true;
          } else {
            return !q.is_post_filter;
          }
        }),
        this.state.voterProfession
      ).sort((a, b) => a.order - b.order);

      this.setState({
        questions,
        questionnaireType: currentType,
        answers: {}, // Reset answers for new questionnaire
        loading: false,
      });
    }
  }

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
    window.removeEventListener("resize", this.setVHValue);
  }
  setVHValue = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  allQuestionsValid() {
    return this.state.questions.every((question) => {
      const answer = this.state.answers[question.id]?.answer;
      if (question.mandatory) {
        switch (question.type) {
          case "text input":
            return answer !== undefined && answer !== "";
          case "number input":
            return answer !== undefined && answer !== "";
          case "dropdown":
            return answer !== undefined && answer !== "";
          case "radio":
            return question.options.includes(answer);
          case "checkbox":
            return Array.isArray(answer) && answer.length > 0;
          default:
            return false;
        }
      }
      return true;
    });
  }

  renderQuestions() {
    return this.state.questions.map((question) => (
      <Form.Group className="mb-2" key={question.id}>
        <Form.Label>{question.question}</Form.Label>
        {question.type === "text input" && (
          <Form.Control
            type="text"
            isInvalid={
              !this.state.allQuestionsAnswered
                ? question.mandatory && !this.state.answers[question.id]?.answer
                : false
            }
            value={this.state.answers[question.id]?.answer || ""}
            onChange={(e) => this.handleAnswerChange(e, question.id)}
          />
        )}
        {question.type === "number input" && (
          <Form.Control
            type="number"
            min="0"
            isInvalid={
              !this.state.allQuestionsAnswered
                ? question.mandatory && !this.state.answers[question.id]?.answer
                : false
            }
            value={this.state.answers[question.id]?.answer || ""}
            onChange={(e) => {
              if (e.target.value >= 0) {
                this.handleAnswerChange(e, question.id);
              }
            }}
          />
        )}
        {["radio", "checkbox"].includes(question.type) &&
          question.options.map((option, index) => (
            <Form.Check
              type={question.type}
              label={option}
              key={index}
              value={option}
              isInvalid={
                !this.state.allQuestionsAnswered
                  ? question.mandatory &&
                    !this.state.answers[question.id]?.answer
                  : false
              }
              checked={
                question.type === "checkbox"
                  ? this.state.answers[question.id]?.answer?.includes(option) ||
                    false
                  : this.state.answers[question.id]?.answer === option
              }
              onChange={(e) =>
                this.handleAnswerChange(e, question.id, question.type)
              }
            />
          ))}
        {question.type === "dropdown" && (
          <Form.Control
            as="select"
            isInvalid={
              !this.state.allQuestionsAnswered
                ? question.mandatory && !this.state.answers[question.id]?.answer
                : false
            }
            value={this.state.answers[question.id]?.answer || ""}
            onChange={(e) => this.handleAnswerChange(e, question.id)}
          >
            <option value="">Select...</option>
            {question.options.map((option, index) => (
              <option value={option} key={index}>
                {option}
              </option>
            ))}
          </Form.Control>
        )}
      </Form.Group>
    ));
  }

  checkConditions() {
    return this.state.questions.every((question) => {
      const answer = this.state.answers[question.id]?.answer;
      // Check for no conditions
      const noConditionsForNumberInput =
        question.condition_int === null ||
        question.condition_int_operator === "";
      const noConditionsForOthers =
        !question.conditions ||
        question.conditions.every((condition) => condition === "");
      let conditionValid = true; // Assume condition is valid initially

      switch (question.type) {
        case "text input":
          // No conditions allowed for text input
          console.log(
            `Question ID ${question.id}: No conditions for text input, always valid.`
          );
          conditionValid = true;
          break;
        case "number input":
          if (noConditionsForNumberInput) {
            console.log(
              `Question ID ${question.id}: No conditions for number input, valid.`
            );
            conditionValid = true;
          } else if (answer === undefined || answer === "") {
            console.log(
              `Question ID ${question.id}: Answer undefined or empty for number input, invalid.`
            );
            conditionValid = false;
          } else {
            const answerNumber = parseInt(answer, 10);
            switch (question.condition_int_operator) {
              case "inferior":
                conditionValid = answerNumber < question.condition_int;
                break;
              case "inferior equal":
                conditionValid = answerNumber <= question.condition_int;
                break;
              case "superior":
                conditionValid = answerNumber > question.condition_int;
                break;
              case "superior equal":
                conditionValid = answerNumber >= question.condition_int;
                break;
              case "equal":
                conditionValid = answerNumber === question.condition_int;
                break;
              default:
                conditionValid = false;
                break;
            }
            console.log(
              `Question ID ${question.id}: Number input condition checked, valid: ${conditionValid}`
            );
          }
          break;
        case "radio":
          conditionValid =
            noConditionsForOthers || question.conditions.includes(answer);
          console.log(
            `Question ID ${question.id}: Radio input condition checked, valid: ${conditionValid}`
          );
          break;
        case "checkbox":
          if (noConditionsForOthers) {
            console.log(
              `Question ID ${question.id}: No conditions for checkbox, valid.`
            );
            conditionValid = true;
          } else if (!Array.isArray(answer)) {
            console.log(
              `Question ID ${question.id}: Answer not an array for checkbox, invalid.`
            );
            conditionValid = false;
          } else {
            console.log(question.conditions);
            conditionValid = question.conditions.every((condition) =>
              answer.includes(condition)
            );
            console.log(
              `Question ID ${question.id}: Checkbox conditions checked, valid: ${conditionValid}`
            );
          }
          break;
        default:
          console.log(
            `Question ID ${question.id}: Default case, always valid.`
          );
          conditionValid = true;
          break;
      }
      return conditionValid;
    });
  }

  handleSubmit = async () => {
    try {
      // Garde anti-race : si le state n'est pas encore synchronisé avec les props
      // (componentDidUpdate en cours de chargement des questions de l'étape), on
      // ignore la soumission. L'utilisateur pourra cliquer une fois l'étape prête.
      if (
        this.state.loading ||
        this.state.questionnaireType !== this.currentQuestionnaireType()
      ) {
        return;
      }

      // On lit le type d'étape depuis les PROPS (à jour immédiatement), pas depuis
      // this.state.questionnaireType qui est synchronisé en différé (race condition).
      const isFilterQuestionnaire = this.currentQuestionnaireType() !== "post_filter";
      const isPostFilterQuestionnaire = this.currentQuestionnaireType() === "post_filter";
      const formPlacement = this.props.location.state.form_placement;
      const position = this.props.location.state.position;

      // Determine if we should process this questionnaire (show questions and validate answers)
      // Filter/base questionnaire: position depends on base_questionnaire_placement
      // Post-filter: process based on form_placement
      const baseQuestionnairePlacement = this.props.location.state.base_questionnaire_placement || "start";
      let shouldProcessQuestions = false;
      if (isFilterQuestionnaire) {
        // Filter questionnaire position depends on base_questionnaire_placement
        shouldProcessQuestions = position === baseQuestionnairePlacement;
      } else {
        // Post-filter position depends on form_placement
        shouldProcessQuestions = position === formPlacement;
      }

      // Check if we can proceed
      // - If questions should be processed, all must be answered
      // - If with_presenter at start, username must be valid (even if no questions)
      let canProceed = true;

      if (shouldProcessQuestions) {
        canProceed = this.allQuestionsAnswered();
      }

      if (this.isUsernameStep()) {
        canProceed = canProceed && this.state.username?.length >= 4;
      }

      // If no questions to process and not with_presenter, we still need to be able to proceed
      if (!shouldProcessQuestions && !this.props.location.state.with_presenter) {
        // This case shouldn't happen in normal flow, but handle it gracefully
        canProceed = true;
      }

      if (!canProceed) {
        this.setState({
          allQuestionsAnswered: false,
        });
        return;
      }

      const withPresenter = this.props.location.state.with_presenter;
      const postFilterEnabled = this.props.location.state.post_filter_questionnaire_enabled;
      // À l'étape filtre, un éligible est suivi d'un post-filtre -> on diffère la
      // création du votant et la sauvegarde des réponses jusqu'à l'étape username.
      const deferToPostFilter =
        withPresenter &&
        position === "start" &&
        isFilterQuestionnaire &&
        postFilterEnabled &&
        formPlacement === "start";

      // Réponses de l'étape courante, sérialisées (checkbox -> "a,b")
      const currentAnswers = shouldProcessQuestions
        ? Object.entries(this.state.answers).map(([questionId, obj]) => ({
            questionId,
            answer: Array.isArray(obj.answer) ? obj.answer.join(",") : obj.answer,
          }))
        : [];

      // Helper: crée le votant (presenter), authentifie, puis sauvegarde les réponses fournies
      const createAuthAndSave = async (username, answers) => {
        if (withPresenter) {
          const voterToCreate = {
            username,
            current_statement_number: 1,
            link: this.props.location.state.unique_link,
          };
          if (Object.values(voterToCreate).some((v) => v === null)) {
            return false;
          }
          await createVoter(this.state.event.id, voterToCreate);
        }
        await authVoter(
          this.state.event.id,
          username,
          this.props.location.state.unique_link
        );
        for (const { questionId, answer } of answers) {
          await createAnswer(questionId, { answer });
        }
        return true;
      };

      // === Étape FILTRE (start) suivie d'un POST-FILTRE : différer ou tracer l'inéligible ===
      if (deferToPostFilter) {
        if (!this.checkConditions()) {
          // Inéligible : on s'arrête au filtre. On crée quand même le votant
          // (pseudo aléatoire) et on sauvegarde sa réponse filtre pour garder la trace.
          await createAuthAndSave(this.generateRandomUsername(), currentAnswers);
          this.setState({ conditionNotMet: true });
          return;
        }
        // Éligible : on ne crée rien maintenant. On transmet les réponses filtre
        // à l'étape post-filtre, qui créera le votant avec le vrai username.
        const pendingAnswers = [
          ...(this.props.location.state.pending_answers || []),
          ...currentAnswers,
        ];
        this.props.navigate(
          "/events/" + this.props.location.state.unique_str + "/voter/register",
          {
            state: {
              ...this.props.location.state,
              questionnaire_type: "post_filter",
              pending_answers: pendingAnswers,
            },
          }
        );
        return;
      }

      // === Étape USERNAME (dernière étape : filtre sans post-filtre, OU post-filtre) ===
      // Création du votant avec le username saisi + sauvegarde de TOUTES les réponses
      // (réponses filtre transmises + réponses de l'étape courante).
      if (position === "start") {
        const username = this.isUsernameStep()
          ? this.state.username
          : this.generateRandomUsername();
        const pendingAnswers = this.props.location.state.pending_answers || [];
        const created = await createAuthAndSave(username, [
          ...pendingAnswers,
          ...currentAnswers,
        ]);
        if (!created) {
          return;
        }
      } else {
        // position === "end" (questionnaire après le vote) : on sauvegarde simplement
        // les réponses sur le votant déjà authentifié.
        for (const { questionId, answer } of currentAnswers) {
          await createAnswer(questionId, { answer });
        }
        if (isPostFilterQuestionnaire && position === "end") {
          await updateUserStatus(this.state.event.id, "finished");
        }
      }

      // Check conditions only for filter questionnaire at start position
      // (conditions are not checked when questionnaire is at end, after voting)
      if (isFilterQuestionnaire && position === "start" && !this.checkConditions()) {
        this.setState({
          conditionNotMet: true,
        });
        return;
      }

      if (isFilterQuestionnaire && position === "end") {
        // Base questionnaire at end is done -> check if post-filter is enabled
        if (postFilterEnabled && formPlacement === "end") {
          // Go to post-filter questionnaire
          this.props.navigate(
            "/events/" + this.props.location.state.unique_str + "/voter/register",
            {
              state: {
                ...this.props.location.state,
                questionnaire_type: "post_filter",
              },
            }
          );
        } else {
          // Mark as finished and go to session (will show finished page)
          await updateUserStatus(this.state.event.id, "finished");
          this.props.navigate(
            "/events/" + this.props.location.state.unique_str + "/voter/session"
          );
        }
      } else if (isFilterQuestionnaire && postFilterEnabled && formPlacement === "start") {
        // Pre-filter done, post-filter enabled and should be shown at start -> go to post-filter
        this.props.navigate(
          "/events/" + this.props.location.state.unique_str + "/voter/register",
          {
            state: {
              ...this.props.location.state,
              questionnaire_type: "post_filter",
            },
          }
        );
      } else if (isPostFilterQuestionnaire && position === "end") {
        // Post-filter at end is done -> go to session (will show finished page)
        this.props.navigate(
          "/events/" + this.props.location.state.unique_str + "/voter/session"
        );
      } else {
        // Aller vers la session de vote
        this.props.navigate(
          "/events/" + this.props.location.state.unique_str + "/voter/session"
        );
      }
    } catch (error) {
      console.log(error);
      this.setState({
        error: error.response.data.detail,
        loading: false,
        showRegisterAlert: "danger",
      });
    }
  };

  render() {
    const lang = this.props.location.state.langage;
    const translations = {
      error: lang === "fr" ? "Erreur" : "Error",
      success: lang === "fr" ? "Succès" : "Success",
      close: lang === "fr" ? "Fermer" : "Close",
      fillInfo:
        this.props.location.state.position == "start"
          ? lang === "fr"
            ? "Informations générales"
            : "General information"
          : lang === "fr"
          ? "Afin de terminer le vote, répondez aux questions suivantes:"
          : "Please fill in the following information:",

      // fillInfoDescription:
      //   lang === "fr"
      //     ? "Afin de pouvoir apporter dans l’article que nous rédigerons quelques informations sur la base des votants et donner ainsi encore plus de poids à ses conclusions, pourriez-vous s’il vous plait répondre aux quelques questions très simples sur votre expérience et votre pratique ci-dessous. Les réponses sont bien entendu totalement anonymes."
      //     : "In order to be able to bring some information into the article that we will write based on the voters and thus give even more weight to its conclusions, could you please answer the few very simple questions about your experience and practice below? The answers are of course completely anonymous.",
      fillInfoDescription: "",
      chooseUsername:
        lang === "fr"
          ? "Entrez un pseudo vous permettant en cas de déconnexion de vous reconnecter à votre session Delphi."
          : "Finally, to start the real-time voting process and ensure you can reconnect if needed, please choose a username you will remember.",
      chooseUsernameDetail:
        lang === "fr"
          ? "Ce pseudo est à retenir et ne doit pas permettre de vous identifier personnellement."
          : "This username should be memorable and should not allow you to be personally identified.",
      usernamePlaceholder: lang === "fr" ? "Nom d'utilisateur" : "Username",
      usernameInvalid:
        lang === "fr"
          ? "Le nom d'utilisateur doit comporter plus de 4 caractères."
          : "Username must be more than 4 characters.",
      register:
        this.props.location.state.position == "start"
          ? lang === "fr"
            ? this.props.location.state.with_presenter
              ? "Commencer"
              : "Continuer"
            : this.props.location.state.with_presenter
            ? "Start"
            : "Continue"
          : lang === "fr"
          ? "Terminer"
          : "Finish",
      conditionNotMet:
        lang === "fr"
          ? "Basé sur vos réponses, vous n'êtes pas éligible au vote Delphi."
          : "Based on your answers, you are not eligible for the Delphi vote.",

      questionMandatory:
        lang === "fr"
          ? "Les questions avec un (*) sont obligatoires."
          : "Questions with (*) are mandatory.",
    };

    console.log(this.props.navigate);
    console.log(this.props.location.state);
    console.log(this.props.location);
    if (this.state.loading) {
      return (
        <Container className="d-flex justify-content-center align-items-center">
          <Spinner />
        </Container>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)", // Updated minHeight
          paddingBottom: this.state.footerHeight + "px",
          backgroundColor: this.state.colors?.background_color,
          position: "relative",
          overflowX: "hidden",
        }}
      >
        {this.state.event && (
          <img
            src={
              this.state.event
                ? BASE_URL +
                  "/events/" +
                  this.state.event.id +
                  "/data/voter_footer"
                : null
            }
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              objectFit: "contain",
            }}
            onLoad={(e) => {
              const h = e.target.getBoundingClientRect().height;
              if (h && Math.round(h) !== this.state.footerHeight) {
                this.setState({ footerHeight: Math.round(h) });
              }
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
            }}
          />
        )}
        <VoterNavBar
          text={this.state.event?.event_title}
          backgroundColor={this.state.colors?.header_background_color}
          img={
            this.state.event
              ? BASE_URL + "/events/" + this.state.event.id + "/data/logo"
              : null
          }
        ></VoterNavBar>

        <Container
          style={{ maxWidth: "800px", marginBottom: "10px" }}
          fluid
          className="px-3 pt-3 flex-grow-1 d-flex flex-column"
        >
          <Alert
            show={this.state.showRegisterAlert !== ""}
            variant={this.state.showRegisterAlert}
          >
            <Alert.Heading>
              {this.state.showRegisterAlert === "danger"
                ? translations.error
                : translations.success}
            </Alert.Heading>
            <p>{"Error when registering voter: " + this.state.error}</p>
            <hr />
            <div className="d-flex justify-content-end">
              <Button
                onClick={() => this.setState({ showRegisterAlert: "" })}
                variant={"outline-" + this.state.showRegisterAlert}
              >
                {translations.close}
              </Button>
            </div>
          </Alert>
          {!this.state.conditionNotMet ? (
            <>
              <h2
                className="text-align-center"
                style={{ color: this.state.colors?.header_background_color }}
              >
                {translations.fillInfo}
              </h2>
              <p className="mb-2 " style={{ fontStyle: "italic" }}>
                {translations.fillInfoDescription}
              </p>
              <Form>
                {/* Filter questionnaire: based on base_questionnaire_placement. Post-filter: based on form_placement */}
                {((this.state.questionnaireType !== "post_filter" && this.props.location.state.position === (this.props.location.state.base_questionnaire_placement || "start")) ||
                  (this.state.questionnaireType === "post_filter" && this.props.location.state.form_placement === this.props.location.state.position)) &&
                  this.renderQuestions()}
                {((this.state.questionnaireType !== "post_filter" && this.props.location.state.position === (this.props.location.state.base_questionnaire_placement || "start")) ||
                  (this.state.questionnaireType === "post_filter" && this.props.location.state.form_placement === this.props.location.state.position)) && (
                  <span className="fw-medium" style={{ fontStyle: "italic" }}>
                    {translations.questionMandatory}
                  </span>
                )}

                {this.isUsernameStep() && (
                    <Form.Group className="mt-4" controlId="username">
                      <Form.Label className="fw-bold">
                        {translations.chooseUsername}
                        <br />
                        <span
                          className="fw-medium"
                          style={{ fontStyle: "italic" }}
                        >
                          {translations.chooseUsernameDetail}
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        placeholder={translations.usernamePlaceholder}
                        value={this.state.username}
                        onChange={this.handleChange}
                        isInvalid={!this.state.isUsernameValid}
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        {translations.usernameInvalid}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}

                <div
                  className="mt-3"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LoadingButton
                    onClick={this.handleSubmit.bind(this)}
                    variant="dark"
                    size="lg"
                    disabled={false}
                  >
                    {translations.register}
                  </LoadingButton>
                </div>
              </Form>
            </>
          ) : (
            <div
              className="flex-grow-1 d-flex align-items-center justify-content-center"
              style={{ textAlign: "center" }}
            >
              <div
                style={{ textAlign: "center", fontSize: "calc(1rem + 2px)" }}
                dangerouslySetInnerHTML={{
                  __html: this.props.location.state.event_refused_message,
                }}
              />
            </div>
          )}
          {this.state.event && this.state.event.legal_notice && (
            <div
              className="text-center mb-2 mt-4"
              style={{
                fontSize: "0.8rem",
                color: this.state.colors?.text_color || "#666",
              }}
            >
              {this.state.event.legal_notice}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

export default withRouter(withTheme(VoterRegister));
